import { render, staticRenderFns } from "./SamErrorMessage.vue?vue&type=template&id=84baf568&scoped=true&"
import script from "./SamErrorMessage.vue?vue&type=script&lang=js&"
export * from "./SamErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./SamErrorMessage.vue?vue&type=style&index=0&id=84baf568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84baf568",
  null
  
)

export default component.exports